
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import '../styles/initG.css';
import AdminDashboardCards from '../components/AdminDashboardCards';
import hola from '../../../assets/hola.jpeg';
import tiburonballo from '../../../assets/tiburonballo.jpeg';

const AdminInit = () => {
  const navigate = useNavigate();
  const [nombreUsuario, setNombreUsuario] = useState('');
  const [legajo, setLegajo] = useState('');

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const storedToken = localStorage.getItem('token');

    if (!storedUser || !storedToken) {
      navigate('/');
      return;
    }

    try {
      const user = JSON.parse(storedUser);
      setNombreUsuario(user?.Nombre || 'Administrador');
      setLegajo(user?.CdUsuario || user?.Legajo || user?.legajo || '');
      console.log('👤 Legajo detectado:', user?.CdUsuario);
    } catch (error) {
      console.error('Error parsing user data:', error);
      setNombreUsuario('Administrador');
    }
  }, [navigate]);

  console.log('🔍 Verificando legajo:', legajo, 'tipo:', typeof legajo, 'muestra imágenes:', (legajo === '43' || legajo === 43 || String(legajo) === '43'));

  return (
    <div className="gerencia-init">
      <Container fluid className="gerencia-content px-3 px-md-4">
        <div className="dash-header">
          <h1 className="welcome-title">
            Bienvenido, <span className="user-name">{nombreUsuario}</span>
          </h1>
        </div>
        
        {(legajo === '43' || legajo === 43 || String(legajo) === '43') && (
          <div className="therian-section" style={{ 
            textAlign: 'center', 
            margin: '30px 0', 
            padding: '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '15px'
          }}>
            <h3 style={{ 
              color: '#fff', 
              fontSize: '24px', 
              margin: '20px 0',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
            }}>
              Hoy tu therian es un tiburonballo
            </h3>
            <img 
              src={tiburonballo} 
              alt="Tiburonballo" 
              style={{ 
                maxWidth: '300px', 
                borderRadius: '10px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }} 
            />
          </div>
        )}
        
        <AdminDashboardCards />
      </Container>
    </div>
  );
};

export default AdminInit;